// Use fetch to create a png Blob from a base64 string
export const base64ToBlob = async (base64: string): Promise<Blob> => {
  const response = await fetch('data:image/png;base64,' + base64);
  const blob = await response.blob();

  return blob;
};
